(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zep-mobile-sticky-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.zepInitialized === 'true') return;
      root.dataset.zepInitialized = 'true';

      const scope = root.closest('.shopify-section') || document;
      const mainButton = scope.querySelector('[data-js-product-button-add-to-cart]');
      const price = scope.querySelector('#js-product-price');
      const stickyButton = root.querySelector('[data-zep-mobile-sticky-button]');
      const stickyLabel = root.querySelector('[data-zep-mobile-sticky-label]');
      const stickyPrice = root.querySelector('[data-zep-mobile-sticky-price]');
      const mobile = window.matchMedia('(max-width: 767px)');
      let mainButtonVisible = true;

      if (!mainButton || !stickyButton) return;

      const isAvailable = () => !mainButton.disabled && !mainButton.classList.contains('d-none-important');

      const synchronize = () => {
        const label = mainButton.querySelector('.text')?.textContent?.trim();
        if (label && stickyLabel) {
          stickyLabel.textContent = label;
          stickyButton.setAttribute('aria-label', label);
        }
        if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
        stickyButton.disabled = !isAvailable();

        const visible = mobile.matches && window.scrollY > 160 && !mainButtonVisible && isAvailable();
        root.hidden = !visible;
        document.body.classList.toggle('zep-mobile-sticky-cart-visible', visible);
      };

      const observer = new IntersectionObserver(([entry]) => {
        mainButtonVisible = entry.isIntersecting;
        synchronize();
      }, { threshold: 0.05 });
      observer.observe(mainButton);

      const changes = new MutationObserver(synchronize);
      changes.observe(mainButton, { attributes: true, childList: true, subtree: true });
      if (price) changes.observe(price, { attributes: true, childList: true, subtree: true });

      stickyButton.addEventListener('click', () => {
        if (!isAvailable()) return;
        mainButton.click();
      });

      window.addEventListener('scroll', synchronize, { passive: true });
      mobile.addEventListener('change', synchronize);
      synchronize();
    };

    const initializeAll = () => document.querySelectorAll('[data-zep-mobile-sticky-cart]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zep-product-gallery-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.zepGalleryReady === 'true') return;
      root.dataset.zepGalleryReady = 'true';

      const main = root.querySelector('[data-slide-main]');
      if (!main) return;

      const markReady = (image) => {
        const slide = image?.closest('.full-item');
        if (!slide) return;
        slide.classList.remove('is-zep-gallery-loading');
        slide.removeAttribute('aria-busy');
        slide.style.removeProperty('--zep-gallery-placeholder');
      };

      const hydrateImage = (image, options = {}) => {
        if (!image || !image.hasAttribute('data-zep-gallery-deferred-image')) return;
        const slide = image.closest('.full-item');
        const placeholder = options.placeholder || '';
        if (slide && !image.complete) {
          slide.classList.add('is-zep-gallery-loading');
          slide.setAttribute('aria-busy', 'true');
          if (placeholder) slide.style.setProperty('--zep-gallery-placeholder', `url(${JSON.stringify(placeholder)})`);
        }
        if (options.priority) {
          image.loading = 'eager';
          image.fetchPriority = 'high';
        }
        image.addEventListener('load', () => markReady(image), { once: true });
        image.addEventListener('error', () => markReady(image), { once: true });
        const srcset = image.getAttribute('data-zep-srcset');
        const src = image.getAttribute('data-zep-src');
        if (srcset) image.setAttribute('srcset', srcset);
        if (src) image.setAttribute('src', src);
        image.removeAttribute('data-zep-srcset');
        image.removeAttribute('data-zep-src');
        image.removeAttribute('data-zep-gallery-deferred-image');
        if (image.complete && image.naturalWidth) markReady(image);
      };

      const hydrateMedia = (mediaId, options = {}) => {
        if (!mediaId) return;
        root.querySelectorAll(`[data-image-id="${CSS.escape(String(mediaId))}"] img[data-zep-gallery-deferred-image]`).forEach((image) => hydrateImage(image, options));
      };

      const hydrateSlide = (index, currentIndex) => {
        const slides = main.querySelectorAll('.full-item:not(.slick-cloned)');
        const slide = slides[Math.max(Number(index) || 0, 0)];
        const currentSlide = slides[Math.max(Number(currentIndex) || 0, 0)];
        const currentImage = currentSlide?.querySelector('img.main-image');
        hydrateMedia(slide?.getAttribute('data-image-id'), {
          priority: true,
          placeholder: currentImage?.currentSrc || currentImage?.src || ''
        });
      };

      const warmSlide = (index) => {
        const slides = main.querySelectorAll('.full-item:not(.slick-cloned)');
        const image = slides[index]?.querySelector('img[data-zep-gallery-deferred-image]');
        if (!image) return;
        const preload = new Image();
        preload.decoding = 'async';
        preload.fetchPriority = 'low';
        preload.sizes = image.sizes;
        preload.srcset = image.getAttribute('data-zep-srcset') || '';
        preload.src = image.getAttribute('data-zep-src') || '';
      };

      const items = main.querySelectorAll('.full-item:not(.slick-cloned)');
      const galleryLayout = root.querySelector('.cms-wrap-main-slider');
      if (galleryLayout?.classList.contains('grid_1_column') || galleryLayout?.classList.contains('grid_2_column')) {
        main.querySelectorAll('img[data-zep-gallery-deferred-image]').forEach(hydrateImage);
      } else if (window.jQuery) {
        window.jQuery(main).on('beforeChange.zepGalleryMedia', (_event, _slick, current, next) => hydrateSlide(next, current));
      }

      const warmAdjacent = () => {
        warmSlide(1);
        if (items.length > 2) window.setTimeout(() => warmSlide(2), 350);
      };
      const scheduleWarm = () => {
        if ('requestIdleCallback' in window) window.requestIdleCallback(warmAdjacent, { timeout: 1500 });
        else window.setTimeout(warmAdjacent, 900);
      };
      if (document.readyState === 'complete') {
        scheduleWarm();
      } else {
        window.addEventListener('load', scheduleWarm, { once: true });
      }

      if (items.length > 1) {
        const counter = document.createElement('output');
        counter.className = 'zep-product-gallery__counter';
        counter.style.cssText = 'position:absolute;right:12px;bottom:12px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:52px;min-width:52px;min-height:30px;padding:4px 10px;border-radius:999px;background:rgb(32 36 42 / 82%);color:#fff;font-size:13px;font-weight:700;line-height:1;pointer-events:none';
        counter.setAttribute('aria-live', 'polite');
        counter.setAttribute('aria-atomic', 'true');
        counter.innerHTML = '<span data-zep-gallery-current>1</span><span aria-hidden="true"> / </span><span data-zep-gallery-total></span>';
        const host = root.querySelector('.wrap-main-slider');
        if (host) host.append(counter);

        const current = counter.querySelector('[data-zep-gallery-current]');
        const total = counter.querySelector('[data-zep-gallery-total]');
        const update = (index) => {
          const count = main.querySelectorAll('.full-item:not(.slick-cloned)').length || items.length;
          const rawIndex = Number(index);
          const safeIndex = count > 0 && Number.isFinite(rawIndex) ? ((rawIndex % count) + count) % count : 0;
          current.textContent = String(safeIndex + 1);
          total.textContent = String(count);
          root.querySelectorAll('[data-slide-nav] .thumb_img:not(.slick-cloned)').forEach((thumb, thumbIndex) => {
            if (thumbIndex === safeIndex) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        };

        const updateFromActiveSlide = () => {
          const active = main.querySelector('.slick-current:not(.slick-cloned)') || main.querySelector('.slick-current');
          if (!active) return;
          const activeIndex = active.getAttribute('data-slick-index');
          if (activeIndex !== null) {
            update(activeIndex);
            return;
          }
          const mediaId = active.getAttribute('data-image-id');
          const slides = [...main.querySelectorAll('.full-item:not(.slick-cloned)')];
          update(slides.findIndex((slide) => slide.getAttribute('data-image-id') === mediaId));
        };

        updateFromActiveSlide();
        if (window.jQuery) window.jQuery(main).on('init reInit afterChange', (_event, _slick, index) => update(index));
        let updateFrame = 0;
        const observer = new MutationObserver((mutations) => {
          if (!mutations.some((mutation) => mutation.target.classList?.contains('slick-current') || mutation.oldValue?.includes('slick-current'))) return;
          window.cancelAnimationFrame(updateFrame);
          updateFrame = window.requestAnimationFrame(updateFromActiveSlide);
        });
        observer.observe(main, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
      }

      root.querySelectorAll('[data-slide-nav] .thumb_img, [data-js-gallery]').forEach((control) => {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          control.click();
        });
      });

      const labelCarouselControls = () => {
        root.querySelectorAll('[data-slide-main] .slick-prev, .main_appendArrows .slick-prev').forEach((button) => button.setAttribute('aria-label', 'Imaginea anterioară'));
        root.querySelectorAll('[data-slide-main] .slick-next, .main_appendArrows .slick-next').forEach((button) => button.setAttribute('aria-label', 'Imaginea următoare'));
        root.querySelectorAll('[data-slide-nav] .slick-prev').forEach((button) => button.setAttribute('aria-label', 'Miniaturile anterioare'));
        root.querySelectorAll('[data-slide-nav] .slick-next').forEach((button) => button.setAttribute('aria-label', 'Miniaturile următoare'));
      };
      labelCarouselControls();
      if (window.jQuery) window.jQuery(main).on('init reInit', labelCarouselControls);
      window.setTimeout(labelCarouselControls, 500);

      root.querySelectorAll('[data-slide-nav] .thumb_img.image[data-thumb-id]').forEach((thumb) => {
        const frame = thumb.querySelector('.pr_lazy_img');
        const mediaId = thumb.getAttribute('data-thumb-id');
        const source = root.querySelector(`#main_img_${CSS.escape(mediaId)} img.main-image`);
        if (!source) return;
        const prepareMedia = () => hydrateMedia(mediaId);
        thumb.addEventListener('pointerenter', prepareMedia, { once: true });
        thumb.addEventListener('focusin', prepareMedia, { once: true });
        thumb.addEventListener('touchstart', prepareMedia, { once: true, passive: true });
        thumb.addEventListener('click', prepareMedia, { capture: true });
        if (!frame || frame.querySelector('img')) return;
        const sourceSet = source.getAttribute('srcset') || source.getAttribute('data-zep-srcset') || '';
        const firstCandidate = sourceSet.split(',')[0].trim().split(/\s+/)[0];
        const thumbnailUrl = (firstCandidate || source.currentSrc || source.src || source.getAttribute('data-zep-src') || '').replace(/([?&])width=\d+/i, '$1width=160');
        if (!thumbnailUrl) return;
        frame.classList.remove('lazyload');
        frame.classList.add('zep-product-gallery__thumb-frame');
        if (source.width && source.height) frame.style.aspectRatio = `${source.width} / ${source.height}`;
        const image = document.createElement('img');
        image.className = 'zep-product-gallery__thumb-image';
        image.src = thumbnailUrl;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = source.width || 160;
        image.height = source.height || 160;
        frame.append(image);
      });

      root.querySelectorAll('[data-zep-deferred-media]').forEach((container) => {
        const poster = container.querySelector('[data-zep-deferred-poster]');
        const template = container.querySelector('template[data-zep-deferred-template]');
        if (!poster || !template) return;
        poster.addEventListener('click', () => {
          if (container.dataset.zepMediaLoaded === 'true') return;
          container.dataset.zepMediaLoaded = 'true';
          const content = template.content.cloneNode(true);
          poster.replaceWith(content);
          template.remove();
          const playable = container.querySelector('video');
          if (playable) playable.play().catch(() => {});
        }, { once: true });
      });
    };

    const initializeAll = () => document.querySelectorAll('.product-cover-thumbnails').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zep-product-quick-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.zepInitialized === 'true') return;
      root.dataset.zepInitialized = 'true';

      const region = root.closest('[data-zep-product-quick-nav-region]');
      const links = [...root.querySelectorAll('[data-zep-quick-nav-link]')];
      const targets = new Map();
      let frame = 0;
      let settledFrame = 0;

      const visibleTarget = (selector) => [...document.querySelectorAll(selector)]
        .find((element) => element.getClientRects().length > 0);

      const refreshTargets = () => {
        links.forEach((link) => {
          const target = visibleTarget(link.dataset.target);
          if (target && link.dataset.anchor && !target.id) target.id = link.dataset.anchor;
          targets.set(link, target || null);
          link.hidden = !target;
          if (target?.id) link.href = `#${target.id}`;
        });
        region.hidden = links.filter((link) => !link.hidden).length < 2;
        updatePosition();
      };

      const headerBottom = () => {
        let bottom = 0;
        document.querySelectorAll('header, .header, .navigationMenu.sticky-header, [data-sticky-header]').forEach((header) => {
          const style = getComputedStyle(header);
          const rect = header.getBoundingClientRect();
          if ((style.position === 'fixed' || style.position === 'sticky') && rect.top <= 1 && rect.bottom > 0 && rect.bottom <= 220) {
            bottom = Math.max(bottom, rect.bottom);
          }
        });
        return bottom > 0 ? Math.ceil(bottom) + 2 : 0;
      };

      const updatePosition = () => {
        frame = 0;
        if (region.hidden) return;
        const top = headerBottom();
        root.style.setProperty('--zep-product-quick-nav-top', `${top}px`);
        root.classList.toggle('is-fixed', region.getBoundingClientRect().top <= top);
        const navigationBottom = root.classList.contains('is-fixed')
          ? top + root.offsetHeight
          : root.getBoundingClientRect().bottom;
        const readingLine = window.scrollY + navigationBottom + 24;
        const available = links
          .filter((link) => !link.hidden && targets.get(link))
          .sort((left, right) => targets.get(left).getBoundingClientRect().top - targets.get(right).getBoundingClientRect().top);
        let active = available[0] || null;
        available.forEach((link) => {
          const targetTop = targets.get(link).getBoundingClientRect().top + window.scrollY;
          if (targetTop <= readingLine) active = link;
        });
        links.forEach((link) => {
          if (link === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      const schedulePosition = () => {
        if (frame) return;
        frame = requestAnimationFrame(updatePosition);
      };

      const scheduleSettledPosition = () => {
        schedulePosition();
        window.clearTimeout(settledFrame);
        settledFrame = window.setTimeout(schedulePosition, 420);
      };

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = targets.get(link);
          if (!target) return;
          event.preventDefault();
          const top = headerBottom() + root.offsetHeight + 12;
          const destination = target.getBoundingClientRect().top + window.scrollY - top;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: Math.max(0, destination), behavior: reducedMotion ? 'auto' : 'smooth' });
          history.replaceState(null, '', `#${target.id}`);
        });
      });

      window.addEventListener('scroll', scheduleSettledPosition, { passive: true });
      window.addEventListener('resize', scheduleSettledPosition, { passive: true });
      document.querySelectorAll('header, .header, .navigationMenu, [data-sticky-header]').forEach((header) => {
        header.addEventListener('transitionend', schedulePosition, { passive: true });
      });
      document.addEventListener('shopify:section:load', refreshTargets);
      [0, 400, 1200, 3000, 7000].forEach((delay) => window.setTimeout(refreshTargets, delay));
    };

    const initializeAll = () => document.querySelectorAll('[data-zep-product-quick-nav]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
